import { fetchJSON } from "../helpers/fetcher"
import { ENVIRONMENT, getEndpoint } from "./endpoints"

export interface GetAccessTokensResponse {
  status: string
  tiktok_shop_name?: string
  veeqo_company_name?: string
}

export interface getSettingsResponse {
  email: string
  link_products_veeqo_tiktok_by_sku_code: boolean
  pull_orders_tiktok_on_hold_status: boolean
  push_inventory_changes_veeqo_to_tiktok: boolean
  sync_orders_tiktok_to_veeqo: boolean
  username_cognito: string
}

export interface updateSettingsResponse {
  status: string
  updatedUserSettings: {
    email: string
    link_products_veeqo_tiktok_by_sku_code: boolean
    pull_orders_tiktok_on_hold_status: boolean
    push_inventory_changes_veeqo_to_tiktok: boolean
    sync_orders_tiktok_to_veeqo: boolean
    username_cognito: string
  }
}

export interface initialOrderSyncResponse {
  data?: string
  error?: any
  code: number
}

const settingsUrl = getEndpoint(ENVIRONMENT)?.settings as string
const checkAccessTokensUrl = getEndpoint(ENVIRONMENT)?.checkAccessTokens as string
const ordersUrl = getEndpoint(ENVIRONMENT)?.ordersUrl as string

export class SettingService {
  static getSettings = async (): Promise<getSettingsResponse> => {
    return await fetchJSON(settingsUrl, "GET")
  }

  static updateSettings = async (body: any): Promise<updateSettingsResponse> => {
    return await fetchJSON(settingsUrl, "POST", body)
  }

  static getAccessTokens = async (): Promise<GetAccessTokensResponse> => {
    return await fetchJSON(checkAccessTokensUrl, "GET")
  }

  static initialOrderSync = async (): Promise<initialOrderSyncResponse> => {
    return await fetchJSON(ordersUrl, "POST", {})
  }
}
